import React, { Component } from "react";
import { Router } from "react-router-dom";
import CustomLayout from "./components/customLayout";
import BaseRouter from './components/routes';
import { ToastContainer } from 'react-toastify';
import { styleMapping } from "./components/utils/tools";
import 'react-toastify/dist/ReactToastify.min.css';
import history from './components/history';
import { getSettings } from "./components/services/general";
import * as actions from './store/pseudo/general';
import { connect } from 'react-redux';
import { initTheme } from './utils/theme';

/**
 * Main application component that handles settings initialization and scroll effects.
 */
class App extends Component {
  /**
   * Initialize component state and bind event handlers.
   * @param {Object} props - Component properties
   */
  constructor(props) {
    super(props);
    this.state = {
      settings: {},
      fields: "",
      newField: "",
      newStructure: "",
    };
    this.selectedKey = "";
    this.selectedFields = {};
    this.oldScroll = 0;
    this.handleScroll = this.handleScroll.bind(this);
  }

  /**
   * Fetch settings on component mount.
   * @async
   */
  async componentDidMount() {
    initTheme();
    try {
      // GET SETTINGS + ARCHITECTURE
      const settings = await getSettings();
      this.props.setSettings(settings);
    } catch (error) {
      console.error('Failed to load settings:', error);
    }

    window.addEventListener("resize", this.handleResize);
    window.addEventListener("scroll", this.handleScroll);
  }

  /**
   * Clean up event listeners when component unmounts.
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
  }

  /**
   * Handle window resize events to adjust layout elements.
   * @param {Event} e - Resize event
   */
  handleResize = (e) => {
    const windowSize = window.innerWidth;
    // Update layout based on window size
    const resizeElements = document.querySelectorAll('.Resize');
    resizeElements.forEach(element => {
      if (element.offsetHeight > 0) {
        const ratio = element.getAttribute('data-ratio');
        if (ratio) {
          const height = parseFloat(ratio) * windowSize;
          element.style.height = `${height}px`;
        }

        const width = window.innerWidth;
        const menuButtons = document.querySelectorAll('.MenuButton');
        if (width < 1090) {
          menuButtons.forEach(btn => btn.style.color = '#ffffff');
        } else {
          menuButtons.forEach(btn => btn.style.color = '#000000');
        }
      }
    });
  }

  /**
   * Handle scroll events to update header appearance.
   * @param {Event} event - Scroll event
   */
  handleScroll = (event) => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const width = window.innerWidth;

    const logoContainer = document.querySelector('.logo_container');
    const menuButtons = document.querySelectorAll('.MenuButton');

    if (!logoContainer) return;

    if (scrollTop > this.oldScroll) {
      // Scrolling down
      logoContainer.style.top = '-150px';
    } else if (scrollTop < this.oldScroll) {
      // Scrolling up
      if (width > 1090) {
        if (scrollTop < 30) {
          logoContainer.style.backgroundColor = '';
          menuButtons.forEach(btn => btn.style.color = '#000000');
        } else {
          logoContainer.style.backgroundColor = '#000000';
          menuButtons.forEach(btn => btn.style.color = '#ffffff');
        }
        logoContainer.style.top = '0px';
      }
    }

    // Reset when at top
    if (scrollTop <= 30) {
      logoContainer.style.backgroundColor = '';
      logoContainer.style.top = '0px';
    }

    this.oldScroll = scrollTop;
  }

  /**
   * Render the main application structure.
   * @returns {JSX.Element|null} The rendered component or null if settings not loaded
   */
  render() {
    if (this.props.settings) {
      return (
        <Router
          history={history}
          className={this.props.settings.structure.body.class}
          style={styleMapping(this.props.settings.structure.body)}
          onScroll={this.handleScroll}>

          <ToastContainer
            position="top-right"
            className="app-toast-container"
            newestOnTop={true}
            closeButton={false}
            closeOnClick={false}
            pauseOnHover={true}
            pauseOnFocusLoss={false}
            draggable={true}
            limit={4}
            icon={false}
            toastClassName="app-toast-shell"
            bodyClassName="app-toast-body-wrap"
            progressClassName="app-toast-progress"
          />
          <CustomLayout {...this.props}>
            <BaseRouter />
          </CustomLayout>
        </Router>
      );
    }
    return null;
  }
}

/**
 * Map Redux state to component props.
 * @param {Object} state - Redux state
 * @returns {Object} Mapped props
 */
const mapStateToProps = (state) => ({
  isAuthenticated: state.status.token !== null && state.status.token !== '' ? true : false,
  status: state.status,
  user: state.user,
  settings: state.settings,
  architecture: state.architecture
});

/**
 * Map dispatch actions to component props.
 * @param {Function} dispatch - Redux dispatch function
 * @returns {Object} Mapped actions
 */
const mapDispatchToProps = dispatch => ({
  setSettings: (data) => dispatch(actions.setSettings2(data)),
  navigate: (direction, history) => dispatch(actions.navigate(direction, history)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
